import { useState, useEffect, Fragment } from "react";
import "./styles.css";

import { RegisterModalObserver, ChangeModalState } from "Interfaces/ModalInterface.js";

import DetailFooter from "../../Assets/detailsmenu.png";

function WelcomeModal(){

  const [showModal, setShowModal] = useState(false);

  function ChangelState(state){
    if(!state){
      window.PlayAvatarVideo();
    }
    setShowModal(state);
  }

  useEffect(()=>{
    RegisterModalObserver("WelcomeModal", ChangelState);
  },[]);

  return (
    <Fragment>
      {showModal ?
      <div className={`modalWelcome`}>
        <div
          className="backdrop"
          onClick={() => {
            ChangeModalState("WelcomeModal", false);           
          }}
        ></div>
        <div className="modalWelcomeContainer">
          <div className="modalWelcomeHeader">
            {/* <button
              onClick={() => {
                ChangeModalState("WelcomeModal", false);              
              }}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_60_419)">
                  <path
                    d="M13 1L1 13"
                    stroke="#00A49D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1 1L13 13"
                    stroke="#00A49D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_60_419">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button> */}
          </div>
          <div className="modalWelcomeContent">
            <div className="divTitleWelcome">
              <h1>Seja bem-vindo!</h1>
            </div>

            <div className="rowContent">
              <div className="svgContainer">
                <svg
                  width="76"
                  height="99"
                  viewBox="0 0 76 99"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_322_320)">
                    <path
                      d="M59 23.3335C59 39.6668 38 53.6668 38 53.6668C38 53.6668 17 39.6668 17 23.3335C17 17.764 19.2125 12.4225 23.1508 8.48425C27.089 4.54599 32.4305 2.3335 38 2.3335C43.5695 2.3335 48.911 4.54599 52.8492 8.48425C56.7875 12.4225 59 17.764 59 23.3335Z"
                      fill="#00A49D"
                    />
                    <path
                      d="M59 23.3335C59 39.6668 38 53.6668 38 53.6668C38 53.6668 17 39.6668 17 23.3335C17 17.764 19.2125 12.4225 23.1508 8.48425C27.089 4.54599 32.4305 2.3335 38 2.3335C43.5695 2.3335 48.911 4.54599 52.8492 8.48425C56.7875 12.4225 59 17.764 59 23.3335Z"
                      stroke="#EDF4F4"
                      strokeOpacity="0.5"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <path
                    d="M50.5988 21.0135C50.5034 21.0135 50.4113 21.0234 50.3225 21.0417L45.28 12.2203C45.5366 11.9645 45.6961 11.6073 45.6961 11.2152C45.6961 10.4344 45.0695 9.7998 44.2949 9.7998C43.6058 9.7998 43.0334 10.3032 42.9167 10.966H32.9534C32.8367 10.3032 32.266 9.7998 31.5752 9.7998C30.8022 9.7998 30.174 10.4328 30.174 11.2152C30.174 11.6571 30.3746 12.0525 30.6904 12.3117L25.6989 21.0467C25.6035 21.0251 25.5032 21.0135 25.4012 21.0135C24.6283 21.0135 24 21.6464 24 22.4289C24 23.2113 24.6266 23.8443 25.4012 23.8443C25.5032 23.8443 25.6035 23.8327 25.6989 23.8111L30.669 32.5079C30.3664 32.767 30.1756 33.1541 30.1756 33.5844C30.1756 34.3652 30.8022 34.9998 31.5769 34.9998C32.2462 34.9998 32.8054 34.5247 32.9436 33.8917H37.3693C37.4828 34.1359 37.7278 34.3054 38.0123 34.3054C38.2969 34.3054 38.5419 34.1359 38.6554 33.8917H42.9298C43.068 34.5263 43.6271 34.9998 44.2965 34.9998C45.0695 34.9998 45.6977 34.3669 45.6977 33.5844C45.6977 33.2023 45.5464 32.8551 45.3014 32.6009L50.3225 23.816C50.4113 23.8343 50.505 23.8443 50.5988 23.8443C51.3717 23.8443 52 23.2113 52 22.4289C52 21.6464 51.3734 21.0135 50.5988 21.0135M44.4807 18.9219L49.362 21.7677C49.2748 21.9338 49.2206 22.1182 49.2058 22.3142H44.4824V18.9219H44.4807ZM49.2041 22.5435C49.2189 22.7395 49.2748 22.9239 49.3604 23.0901L44.8886 25.6983C44.7866 25.572 44.6435 25.479 44.4791 25.4458V22.5435H49.2025H49.2041ZM43.6271 26.1518C43.6271 26.2415 43.6452 26.3262 43.6748 26.406L41.2309 27.8314L38.208 22.5435H44.2521V25.4391C43.9001 25.4823 43.6255 25.783 43.6255 26.1502M31.7693 26.0671V23.11C32.0768 23.0751 32.3268 22.8442 32.3877 22.5418H37.8133L34.9253 27.5938C34.8941 27.5872 34.8628 27.5822 34.83 27.5822C34.7231 27.5822 34.626 27.6237 34.5537 27.6918L31.7693 26.0687V26.0671ZM35.1243 27.7051L38.0107 22.6565L41.0335 27.9443L38.0107 29.707L35.2362 28.0889C35.2428 28.0606 35.246 28.0307 35.246 28.0008C35.246 27.8862 35.2 27.7815 35.126 27.7051M37.7344 15.3086C37.8084 15.3751 37.9038 15.4183 38.0107 15.4183C38.1176 15.4183 38.213 15.3767 38.287 15.3086L40.5073 16.6028C40.4678 16.6925 40.4448 16.7905 40.4448 16.8951C40.4448 17.1244 40.5533 17.3271 40.7178 17.4583L38.009 22.1963L34.9862 16.9084L37.7311 15.307L37.7344 15.3086ZM41.1585 17.6161C41.3954 17.6161 41.6042 17.4982 41.7325 17.3188L44.2505 18.7873V22.3126H38.2064L40.9168 17.5713C40.9924 17.5995 41.073 17.6161 41.1585 17.6161ZM44.2521 12.6256V18.5232L41.8361 17.1144C41.8575 17.0447 41.8723 16.9732 41.8723 16.8968C41.8723 16.6759 41.772 16.4815 41.6174 16.3486L43.7965 12.5343C43.938 12.5891 44.0926 12.6207 44.2521 12.6256M43.591 12.4346L41.4233 16.2273C41.3411 16.1941 41.2523 16.1741 41.1585 16.1741C40.9497 16.1741 40.7638 16.2672 40.6339 16.41L38.4087 15.1126C38.4186 15.076 38.4268 15.0378 38.4268 14.998C38.4268 14.9681 38.4235 14.9382 38.4169 14.9099L43.2143 12.1123C43.3196 12.2419 43.4479 12.3499 43.591 12.4346M32.9074 11.6538H42.966C42.9972 11.7485 43.0384 11.8399 43.0861 11.9246L38.31 14.7106C38.2344 14.6325 38.1291 14.5826 38.0123 14.5826C37.8956 14.5826 37.7903 14.6325 37.7147 14.7106L32.8219 11.8581C32.8547 11.7933 32.8827 11.7252 32.9057 11.6555M32.7018 12.0542L37.6061 14.9132C37.5995 14.9415 37.5962 14.9714 37.5962 15.0013C37.5962 15.0412 37.6028 15.0794 37.6143 15.1159L34.876 16.7124L32.391 12.3648C32.511 12.2784 32.6163 12.1721 32.7034 12.0525M31.7709 12.614C31.9222 12.5924 32.0637 12.5476 32.1969 12.4811L34.6803 16.8254L31.7726 18.5215V12.614H31.7709ZM34.7938 17.0247L37.8166 22.3126H32.3942C32.3548 21.9837 32.0982 21.7245 31.7709 21.6863V18.7873L34.7938 17.0247ZM30.9864 22.3126H26.7959C26.7811 22.1215 26.7285 21.9405 26.6446 21.7777L31.544 18.9202V21.6946C31.2479 21.7577 31.0226 22.0053 30.9864 22.3126ZM31.3121 12.6024C31.3877 12.6173 31.465 12.6256 31.544 12.6273V18.6561L26.5229 21.5833C26.4604 21.4986 26.3897 21.4205 26.3107 21.3524L31.3104 12.6041L31.3121 12.6024ZM31.544 32.1706C31.4552 32.1723 31.3663 32.1823 31.2825 32.2005L26.3091 23.5037C26.388 23.4356 26.4587 23.3575 26.5212 23.2728L31.5423 26.2V32.1706H31.544ZM26.6446 23.0784C26.7285 22.9156 26.7811 22.7346 26.7959 22.5435H30.9914C31.0473 22.8243 31.266 23.0469 31.544 23.105V25.9358L26.6446 23.0784V23.0784ZM31.7709 32.1856V26.3346L34.4352 27.8879C34.4254 27.9244 34.4172 27.9626 34.4172 28.0025C34.4172 28.1138 34.4616 28.2151 34.5306 28.2899L32.2216 32.3301C32.0834 32.257 31.9305 32.2089 31.7709 32.1856M32.414 32.4531L34.728 28.4062C34.7625 28.4145 34.7971 28.4211 34.8332 28.4211C34.95 28.4211 35.0553 28.3713 35.1309 28.2932L37.7854 29.8415L32.733 32.787C32.6459 32.6574 32.5373 32.5461 32.414 32.4531M42.9479 33.2023H38.6143C38.4876 32.9996 38.2656 32.8651 38.0123 32.8651C37.7591 32.8651 37.5354 33.0013 37.4104 33.2023H32.9238C32.9024 33.1275 32.8761 33.0561 32.8449 32.9863L38.0123 29.9728L43.0614 32.9166C43.0137 33.0063 42.9775 33.101 42.9495 33.2006M43.1864 32.7238L38.2393 29.8399L41.1487 28.1437L43.5679 32.3766C43.4199 32.468 43.29 32.586 43.1847 32.7238M43.7702 32.272L41.3444 28.0274L43.7883 26.602C43.9018 26.7432 44.0646 26.8379 44.2521 26.8612V32.1706C44.0811 32.1756 43.9199 32.2105 43.7702 32.272M44.7208 32.2354C44.6435 32.2105 44.5629 32.1922 44.4791 32.1823V26.8562C44.8063 26.7897 45.0514 26.499 45.0514 26.1502C45.0514 26.0604 45.0333 25.9741 45.0037 25.8943L49.4837 23.2811C49.5478 23.3675 49.6218 23.4472 49.7041 23.517L44.7208 32.2354V32.2354ZM49.4837 21.5733L44.4791 18.6544V12.6157C44.5514 12.6057 44.6238 12.5908 44.6929 12.5708L49.7041 21.3391C49.6218 21.4088 49.5478 21.4886 49.4837 21.575"
                    fill="#EDF4F4"
                  />
                  <defs>
                    <filter
                      id="filter0_d_322_320"
                      x="0"
                      y="1.3335"
                      width="76"
                      height="97.3335"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="28" />
                      <feGaussianBlur stdDeviation="8" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0.643137 0 0 0 0 0.615686 0 0 0 0.7 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_322_320"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_322_320"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              <p>
                Clique nos pins de navegação para se aproximar de cada área.
              </p>
            </div>

            <div className="rowContent">
              <div className="svgContainer">
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M55.8136 31.1165C52.5614 27.6836 48.2251 25.3347 43.7081 24.4313C41.7206 23.8893 39.7332 23.5279 37.7457 23.3473C42.8047 17.3849 41.9013 8.35091 35.9389 3.29191C29.9765 -1.7671 20.9426 -0.863709 15.8835 5.09869C10.8245 11.0611 11.7279 20.095 17.6903 25.154C18.7744 26.0574 19.8585 26.7802 20.9426 27.1415V31.1165L18.0517 28.4063C15.5222 25.8768 11.3666 25.8768 8.65639 28.4063C6.12689 30.9358 5.94621 34.9107 8.47571 37.4402L16.7869 47.1969C17.1483 49.7264 18.0517 52.0752 19.3164 54.2433C20.2198 55.8695 21.4846 57.4956 22.7493 58.7603V62.1932C22.7493 63.2773 23.4721 64 24.5561 64H49.1285C50.0319 64 50.9352 63.0966 50.9352 62.1932V57.4956C54.3681 53.34 56.1749 48.1003 56.1749 42.8606V32.3812C56.3556 31.6585 56.1749 31.2971 55.8136 31.1165ZM16.0642 14.1326C16.0642 8.17023 20.9426 3.47258 26.905 3.65326C32.8674 3.65326 37.565 8.53159 37.3843 14.494C37.3843 17.7462 35.9389 20.6371 33.4094 22.6245V13.5906C33.3171 12.0248 32.6294 10.5536 31.4872 9.47856C30.345 8.40354 28.8348 7.80616 27.2663 7.80888C24.0141 7.6282 21.1232 10.3384 21.1232 13.5906V22.9859C18.0517 21.1791 16.2449 17.7462 16.0642 14.1326ZM52.742 42.6799C52.9227 47.3776 51.2966 51.8945 48.2251 55.5081C47.8637 55.8695 47.5023 56.2308 47.5023 56.7729V60.5671H26.5436V58.0376C26.5436 57.4956 26.1822 56.9535 25.8209 56.5922C24.5561 55.5081 23.4721 54.2433 22.5687 52.6172C21.4846 50.8104 20.7619 48.6423 20.4005 46.4742C20.4005 46.1128 20.2198 45.7514 20.0392 45.3901L11.3666 35.0914C10.8245 34.5494 10.4632 33.8266 10.4632 32.9232C10.4632 32.2005 10.8245 31.2971 11.3666 30.7551C12.6313 29.671 14.4381 29.671 15.7029 30.7551L20.9426 35.9948V41.4151L24.3755 39.6084V13.5906C24.5561 12.3258 25.6402 11.2418 27.0856 11.4225C28.3504 11.4225 29.6151 12.3258 29.6151 13.5906V34.3687L33.2287 35.0914V26.7802C33.4094 26.5995 33.5901 26.5995 33.7708 26.4188C35.0355 26.4188 36.3003 26.5995 37.565 26.7802V35.9948L40.4559 36.5368V27.1415L42.624 27.6836C43.5274 27.8642 44.4308 28.2256 45.3342 28.5869V37.6209L48.2251 38.1629V29.8517C49.8512 30.5744 51.2966 31.6585 52.5614 32.9232L52.742 42.6799Z"
                    fill="#79BA6D"
                  />
                </svg>
              </div>
              <div className="paragraphResponsive">
                <p>Clique na tela e arraste para navegar pelo ambiente 360º</p>
              </div>
            </div>
            <div className="btn_acessar">
              <button onClick={()=>{ChangeModalState("WelcomeModal", false);}} >ACESSAR</button>
            </div>
          </div>
          <div className="modalWelcomeFooter">
            <img src={DetailFooter}  alt=""  />
          </div>
        </div>
      </div>
      :null}
    </Fragment>    
  );
}

export default WelcomeModal;
